import React from "react";
import styles from "./styles.module.scss";
import useDomainStore from "../../../stores/domain";

export const NumberInput = ({
  id,
  name,
  label,
  value,
  min = 0,
  max,
  suffix,
  touched = false,
  errored = false,
  error = "",
  onChange,
  ...props
}) => {
  const { isKurvDomain } = useDomainStore();
  const handleChange = (e) => {
    const inputValue = e.target.value;

    // Allow empty value
    if (inputValue === "") {
      onChange("");
      return;
    }

    const newValue = parseInt(inputValue);

    // Handle invalid number
    if (isNaN(newValue)) {
      onChange("");
      return;
    }

    // Handle max/min constraints
    if (max !== undefined && newValue > max) {
      onChange(max);
      return;
    }

    if (min !== undefined && newValue < min) {
      onChange(min);
      return;
    }

    onChange(newValue);
  };

  const hasError = touched && errored && error;

  return (
    <div className={`${styles.formGroup} ${isKurvDomain ? styles.kurv_theme : ""}`}>
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
      <div
        className={`${styles.inputWrapper} ${hasError && styles.errorInput} ${isKurvDomain ? styles.kurv_theme : ""}`}
      >
        <input
          className={`${styles.input} ${suffix ? styles.suffixInput : ""}`}
          type="number"
          id={id}
          name={name}
          value={value}
          min={min}
          max={max}
          onChange={handleChange}
          {...props}
        />
        {suffix && <span className={styles.suffix}>{suffix}</span>}
      </div>
      {hasError && <span className={styles.error}>{error}</span>}
    </div>
  );
};

export default NumberInput;
